import { render, staticRenderFns } from "./ModelPoint.vue?vue&type=template&id=1b28a2ce&"
import script from "./ModelPoint.vue?vue&type=script&lang=js&"
export * from "./ModelPoint.vue?vue&type=script&lang=js&"
import style0 from "./ModelPoint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports